import request from '@/utils/request'

export function saveMapCfg(data) {
  return request({
    url: 'api/v1/map/saveMapCfg',
    method: 'post',
    data: data
  })
}

export function getMapCfg() {
  return request({
    url: 'api/v1/map/getMapCfg',
    method: 'get'
  })
}

export function exportMapCfg() {
  return request({
    url: 'api/v1/map/exportMapCfg',
    method: 'get'
  })
}

export function exportJsonMapCfg() {
  return request({
    url: 'api/v1/map/exportJsonMapCfg',
    method: 'get'
  })
}

export function importMapCfg(data) {
  return request({
    url: 'api/v1/map/importMapCfg',
    method: 'post',
    data: data
  })
}
